/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _get from 'lodash/get';
import _startsWith from 'lodash/startsWith';
import Image from './Image';

const AssetThumbnail = ({ source, record = {}, title, size }) => {
  let width;
  switch (size) {
    case 'M':
      width = '200';
      break;
    case 'L':
      width = '400';
      break;
    default:
      width = '50';
  }

  const imageUrl = _get(record, source);

  const isBlob = _startsWith(imageUrl, 'blob');

  return (
    <ImageContainer width={width}>
      {isBlob ? (
        <img
          src={imageUrl}
          width={width}
          alt={`${record[title]} thumbnail`}
          title={record[title]}
        />
      ) : (
        <Image
          imageUrl={imageUrl}
          width={width}
          backgroundColor={'255,255,255'}
          alt={`${record[title]} thumbnail`}
          title={record[title]}
        />
      )}
    </ImageContainer>
  );
};

const ImageContainer = styled.div`
  width: ${({ width }) => width}px;
  height: ${({ width }) => width}px;
  overflow: hidden;

  img {
    width: ${({ width }) => width}px;
    height: ${({ width }) => width}px;
  }
`;

AssetThumbnail.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
  title: PropTypes.string,
  size: PropTypes.string,
};

AssetThumbnail.defaultProps = {
  record: {},
  title: '',
  size: 'S',
};

export default AssetThumbnail;
